import { render, staticRenderFns } from "./MonthEquipParaList.vue?vue&type=template&id=1f508720&"
import script from "./MonthEquipParaList.vue?vue&type=script&lang=js&"
export * from "./MonthEquipParaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports